// src/config/niveis.js
export const NIVEIS = {
  DASHBOARD: 0,
  KIOSK: 1,
  CLIENTE: 2,
  TECNICO: 3,
  TECNICO_SENIOR: 4,
  ADMIN: 5,
  GESTOR: 6,
};

export const LABEL_NIVEIS = {
  0: "Dashboard",
  1: "Kiosk",
  2: "Cliente",
  3: "Técnico",
  4: "Técnico Sênior",
  5: "Administrador",
  6: "Gestor",
};
